import { render, staticRenderFns } from "./GlobalSearchStartupResult.vue?vue&type=template&id=21fb574b&"
import script from "./GlobalSearchStartupResult.vue?vue&type=script&lang=js&"
export * from "./GlobalSearchStartupResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports